import {
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react"
import type React from "react"

import { useField } from "formik"

interface ConsentCheckboxProps {
  label: string
  name: string
  description: string
  id?: string
  [key: string]: string | undefined // Allow additional props
}
const ConsentCheckbox: React.FC<ConsentCheckboxProps> = ({
  label,
  description,
  ...props
}) => {
  const [field, meta] = useField({ ...props, type: "checkbox" })

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      <FormLabel htmlFor={(props.id as string) || props.label}>
        <strong>{label}</strong>
      </FormLabel>
      <Checkbox {...field} {...props} checked={field.value}>
        {description}
      </Checkbox>

      {meta.touched && meta.error ? (
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      ) : null}
    </FormControl>
  )
}

export default ConsentCheckbox
